import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  buildPowerAutomateGetBatchBody,
  chunkPowerAutomateBatchRequests,
  parsePowerAutomateBatchResponse,
  POWER_AUTOMATE_BATCH_LIMIT,
  POWER_AUTOMATE_BATCH_URL,
  PowerAutomateBatchRequest,
  PowerAutomateBatchResponse,
} from './power-automate-batch.util';

export {
  isPowerAutomateFlowNotFoundResponse,
  PowerAutomateBatchRequest,
  PowerAutomateBatchResponse,
} from './power-automate-batch.util';

export interface PowerAutomateBatchOptions {
  limit?: number;
  bearerToken?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PowerAutomateBatchService {
  constructor(private httpClient: HttpClient) {}

  async get(requests: PowerAutomateBatchRequest[], options: PowerAutomateBatchOptions = {}): Promise<PowerAutomateBatchResponse[]> {
    const chunks = chunkPowerAutomateBatchRequests(requests || [], options.limit || POWER_AUTOMATE_BATCH_LIMIT);
    const responses: PowerAutomateBatchResponse[] = [];

    for (const chunk of chunks) {
      responses.push(...await this.sendGetChunk(chunk, options.bearerToken));
    }

    return responses;
  }

  buildGetBody(requests: PowerAutomateBatchRequest[]): { requests: any[] } {
    return buildPowerAutomateGetBatchBody(requests);
  }

  parseResponse(body: string, requests: PowerAutomateBatchRequest[] = []): PowerAutomateBatchResponse[] {
    return parsePowerAutomateBatchResponse(body, requests);
  }

  private async sendGetChunk(requests: PowerAutomateBatchRequest[], bearerToken?: string): Promise<PowerAutomateBatchResponse[]> {
    const body = this.buildGetBody(requests);
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      Accept: 'application/json, text/plain, */*',
    };
    if (bearerToken) {
      headers.Authorization = `Bearer ${bearerToken}`;
    }
    const response = await firstValueFrom(this.httpClient.post(POWER_AUTOMATE_BATCH_URL, body, {
      headers: new HttpHeaders(headers),
      observe: 'response',
      responseType: 'text',
    }));

    return this.parseHttpResponse(response, requests);
  }

  private parseHttpResponse(response: HttpResponse<string>, requests: PowerAutomateBatchRequest[]): PowerAutomateBatchResponse[] {
    return this.parseResponse(response.body || '', requests);
  }
}
